import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    variant?: "default" | "progress"
  }
>(({ className, variant = "default", ...props }, ref) => {
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex w-full touch-none select-none items-center group",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className={cn(
          "relative w-full grow rounded-full",
          variant === "progress"
            ? "h-1 bg-white/20 overflow-visible"
            : "h-2 bg-secondary overflow-hidden"
        )}
      >
        <SliderPrimitive.Range
          className={cn(
            "absolute h-full rounded-full overflow-visible",
            variant === "progress"
              ? "bg-white"
              : "bg-primary"
          )}
        />
        {variant === "progress" && (
          <div
            className="absolute top-1/2 -translate-y-1/2 h-3 pointer-events-none z-10"
            style={{
              left: `calc(${((props.value?.[0] || 0) / (props.max || 100)) * 100}% - 50px)`,
              width: '50px',
              background: 'linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.5) 100%)',
              filter: 'blur(5px)',
              borderRadius: '0 50% 50% 0'
            }}
          />
        )}
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          "block rounded-full ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
          variant === "progress"
            ? "h-3 w-3 bg-white border-0 opacity-0 group-hover:opacity-100 shadow-[0_0_12px_rgba(255,255,255,0.9)]"
            : "h-5 w-5 border-2 border-primary bg-background"
        )}
      />
    </SliderPrimitive.Root>
  );
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
